module.exports = __webpack_public_path__ + "static/img/icon_4.c614a70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flow/icon_4.png
// module id = Gfqk
// module chunks = 0